import { defineStore } from 'pinia'
import { paymentApiAxiosInstance } from '@/helpers/request'
import { useSubscriptionStore } from './subscription'
import { sessionOrPreviewStorage, sharedKeyPersist } from './persistence'

export const usePaltaStore = defineStore('palta', {
	state: () => ({}),

	actions: {
		purchase({ userId, ident, paymentType, paymentDiscounts }) {
			return paymentApiAxiosInstance.post('v1/api/payment/paltabrain', {
				user_id: userId,
				ident,
				payment_type: paymentType,
				payment_discounts: paymentDiscounts,
			})
		},

		switchSubscription(params) {
			const { deferred = false, ...apiParams } = params
			if (deferred) {
				const { userId, subscriptionId, ident, subscriptionType } = apiParams
				return paymentApiAxiosInstance
					.post('/v1/api/subscription/paltabrain/migrate-deferred', {
						user_id: userId,
						subscription_id: subscriptionId,
						plan: ident,
						subscription_type: subscriptionType,
					})
					.then((response) => response.data)
			}
			const { userId, ident, paymentType, excludeTrialAmount = false } = apiParams
			return paymentApiAxiosInstance
				.post('v2/api/subscription/paltabrain/upgrade', {
					user_id: userId,
					ident,
					payment_type: paymentType,
					exclude_trial_amount: excludeTrialAmount,
				})
				.then((response) => response.data)
		},

		cancelSubscription(params) {
			return paymentApiAxiosInstance.post('v1/api/subscription/paltabrain/cancel', params)
		},

		pauseSubscription(params) {
			const subsStore = useSubscriptionStore()
			return paymentApiAxiosInstance.post('v1/api/subscription/paltabrain/pause', params).then(() => {
				subsStore.setSubscription({
					...subsStore.getSubscription,
					paused_until_at: params.pause_until,
					is_pause_allowed: false,
					is_paused: true,
				})
			})
		},

		resumeSubscription(params) {
			const subsStore = useSubscriptionStore()
			return paymentApiAxiosInstance.post('v1/api/subscription/paltabrain/resume', params).then(() => {
				subsStore.setSubscription({
					...subsStore.getSubscription,
					paused_until_at: null,
					is_pause_allowed: false,
					is_paused: false,
				})
			})
		},

		chargeFee({ subscriptionId, amount }) {
			const subsStore = useSubscriptionStore()
			return paymentApiAxiosInstance
				.post('/v1/api/subscription/paltabrain/charge-fee', {
					subscription_id: subscriptionId,
					amount,
				})
				.then((response) => {
					const data = response.data
					subsStore.setSubscription({
						...subsStore.getSubscription,
						cancelled: true,
						canceled_at: new Date().toISOString(),
						billing_periods_before_cancellation: 0,
					})
					return data
				})
		},

		createSubscription(params) {
			return paymentApiAxiosInstance.post('/v1/api/subscriptions', params).then((response) => {
				if (response.data.checkoutState !== 'completed') {
					throw new Error('Palta subscription failed', { cause: response })
				}

				return response.data
			})
		},
	},

	persist: sharedKeyPersist('vuex', 'palta', sessionOrPreviewStorage),
})
